import {createAsyncThunk} from '@reduxjs/toolkit';
import {apiInstance, apiInstanceUpdate, apiInstanceValidas, apiInstanceVeridas} from '../../Apis/Axios';
import {toast} from 'react-toastify';
import {useTranslation} from 'react-i18next';
import {errorCodeTranslation} from "../../Apis/ErrorCode";
import {apiInstanceV2} from "../../Apis/AxiosV2";
import {VALIDAS_SERVICE, VERIDAS_SERVICE} from '../EndPoints';

const config = {
    headers: {
        'content-type': 'multipart/form-data',
    },
};

const configJson = {
    headers: {
        'Content-Type': 'application/json',
    },
};

const USER_SERVICE = "user-service/"
// get all document types /available-types/{countryCode} veridas-module validas-controller
export const GetAllDocumentFormats = createAsyncThunk(
    'document/getAllAvailableTypes',
    async (countryCode, { dispatch, getState }) => {
        const result = await apiInstanceValidas
            .get(`available-types/${countryCode}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                const status = error.response?.status;

                const errorMessage = status && errorCodeTranslation[status] ? errorCodeTranslation[status] : null;
                const { t } = useTranslation();
                toast.error(t(errorMessage));
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
/* /validation veridas-module validas-controller */
export const GetValidationId = createAsyncThunk('document/getValidationId', async (params, { dispatch, getState }) => {
    const result = await apiInstanceValidas
        .get('validation')
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            const status = error.response?.status;

            const errorMessage = status && errorCodeTranslation[status] ? errorCodeTranslation[status] : null;
            const { t } = useTranslation();
            toast.error(t(errorMessage));
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

/* /user-service/restriction/get user-module user-controller */
export const GetUserRestrictionVisitor = createAsyncThunk(
    'document/getUserRestrictionVisitor',
    async () => {
        const result = await apiInstanceUpdate
            .get(`${USER_SERVICE}restriction/get`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                const status = error.response?.status;

                const errorMessage = status && errorCodeTranslation[status] ? errorCodeTranslation[status] : null;
                const { t } = useTranslation();
                toast.error(t(errorMessage));
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
/* /user-service/identity-validation/{userId}  user service  */
export const GetValidateIdentifyById = createAsyncThunk(
    'document/getValidateIdentifyById',
    async (userId, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${USER_SERVICE}identity-validation/${userId}`)
            .then(function (response) {
                return response.data.data;
            })
            .catch(function (error) {
                const status = error.response?.status;

                const errorMessage = status && errorCodeTranslation[status] ? errorCodeTranslation[status] : null;
                const { t } = useTranslation();
                toast.error(t(errorMessage));
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
export const ValidationProcessCancel = createAsyncThunk(
    'document/validationProcessCancel',
    async (validationId, { dispatch, getState }) => {
        const result = await apiInstanceValidas
            .get(`cancellation/${validationId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                const status = error.response?.status;

                const errorMessage = status && errorCodeTranslation[status] ? errorCodeTranslation[status] : null;
                const { t } = useTranslation();
                toast.error(t(errorMessage));
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetIdentityValidationType = createAsyncThunk('document/getIdentityValidationType',
    async (params, { dispatch, getState }) => {
        const response = await apiInstanceVeridas.get(VERIDAS_SERVICE.getIdentityValidationType)
            .then(function (response) {
                return response;
            }).catch(function (error) {
                return error.response;
            });
        return response;
    },
);

export const GetDocumentValidationStatus = createAsyncThunk(
    'document/getDocumentValidationStatus',
    async ({ validationId }, { dispatch, getState }) => {
        const response = await apiInstance
            .post(VALIDAS_SERVICE.getDocumentValidationStatus, null, {
                params: { validationId },
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                const status = error.response?.status;

                const errorMessage = status && errorCodeTranslation[status] ? errorCodeTranslation[status] : null;
                const { t } = useTranslation();
                toast.error(t(errorMessage));
                return error.response;
            });
        const { data, status } = response;

        return { data, status };
    },
);

const createFormData = async (
    {
        documentImage,
        analysisType,
        documentType,
        validationId,
        userId,
    }
) => {
    try {
        const blob = await fetch(documentImage).then((res) => res.blob());
        const file = new File([blob], 'filename.jpeg', { type: 'image/jpeg' });

        const formData = new FormData();
        formData.append('analysisType', analysisType);
        formData.append('documentImage', file);
        formData.append('documentType', documentType);
        formData.append('validationId', validationId);
        formData.append('userId', userId);

        return formData;
    } catch (error) {
        return null;
    }
};

export const UpdateIdentityValidationType = createAsyncThunk('document/updateIdentityValidationType',
    async ({ userId, validationType}) => {
        const response = await apiInstanceVeridas.put(`${USER_SERVICE}public/user/update-validation-type/${userId}/${validationType}`, null, configJson)
            .then(function (response) {
                return response;
            }).catch(function (error) {
                return error.response;
            });
        return response;
    },
);

/* /* /* /validation/obseve-document veridas-module validas-controller */
export const ValidateObverseDocument = createAsyncThunk('document/validateObverseDocument',
    async ({ analysisType, documentImage, documentType, validationId, userId }) => {
            const formData = await createFormData({
                documentImage: documentImage,
                analysisType: analysisType,
                documentType: documentType,
                validationId: validationId,
                userId: userId,
            });
        return await apiInstanceVeridas.put(VALIDAS_SERVICE.validateObverseDocument, formData, config)
                .then(function (response) {
                    return response;
                }).catch(function (error) {
                    return error.response;
                });
    },
);
/* /* /* /validation/obseve-document veridas-module validas-controller */
export const ValidateReverseDocument = createAsyncThunk('document/validateReverseDocument',
    async ({ analysisType, documentImage, documentType, validationId, userId }) => {
            const formData = await createFormData({
                documentImage: documentImage,
                analysisType: analysisType,
                documentType: documentType,
                validationId: validationId,
                userId: userId,
            });
            const response = await apiInstanceVeridas.put(VALIDAS_SERVICE.validateReverseDocument, formData, config)
                .then(function (response) {
                    return response;
                }).catch(function (error) {
                    return error.response;
                });
            return response;
    },
);
export const VeridasServiceProcess = createAsyncThunk('document/veridasServiceProcess',
    async ({ validationId, userId }) => {
            const response = await apiInstanceVeridas.get(VALIDAS_SERVICE.veridasServiceProcess, { params: { validationId, userId }, ...configJson})
            .then(function (response) {
                return response;
            }).catch(function (error) {
                return error.response;
            });
        return response;
    },
);

export const ValidateSelfie = createAsyncThunk(
    'document/validateSelfie',
    async ({ image, imageAlive, validationId }) => {
        const blobImage = await fetch(image).then((res) => res.blob());
        const fileImage = new File([blobImage], 'filename.jpeg', { type: 'image/jpeg' });

        const blobAlive = await fetch(imageAlive).then((res) => res.blob());
        const fileAlive = new File([blobAlive], 'filename.jpeg', { type: 'image/jpeg' });

        const formData = new FormData();
        formData.append('image', fileImage);
        formData.append('imageAlive', fileAlive);
        formData.append('validationId', validationId);

        return await apiInstanceValidas.put('validation/selfie', formData, config)
            .then(function (response) {
                return response;
            }).catch(function (error) {
                return error.response;
            });
    },
);
/* /validation/{id}/token
id: Mismo que se obuvo de la petición pasada
veridas-module validas-controller */
export const GetTokenChallenge = createAsyncThunk(
    'document/getTokenChallenge',
    async (validationId, { dispatch, getState }) => {
        const result = await apiInstanceValidas
            .get(`validation/${validationId}/token`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                const status = error.response?.status;

                const errorMessage = status && errorCodeTranslation[status] ? errorCodeTranslation[status] : null;
                const { t } = useTranslation();
                toast.error(t(errorMessage));
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
/* /validation/video-photo
veridas-module validas-controller */
export const ValidateVideoPhoto = createAsyncThunk('document/validateVideoPhoto',
    async ({ annotations, challenge, selfie, validationId, video, userId }) => {

    const blobImage = await fetch(selfie).then((res) => res.blob());
    const fileImage = new File([blobImage], 'filename.jpeg', { type: 'image/jpeg' });

    const annotationsBlob = new Blob([annotations], { type: 'text/vtt' });

    const formData = new FormData();
    formData.append('annotations', annotationsBlob);
    formData.append('selfie', fileImage);
    formData.append('video', video);
    formData.append('challenge', challenge);
    formData.append('validationId', validationId);
    formData.append('userId', userId);


    const response = await apiInstanceVeridas.put(VALIDAS_SERVICE.validateVideoPhoto, formData, config)
        .then(function (response) {
            return response;
        }).catch(function (error) {
            return error.response;
        });
    return response;
    }
);

/* /v1/validation/update-data
veridas-module validas-controller */

export const updateContextualData = createAsyncThunk(
    'document/updateContextualData',
    async (validationId, { dispatch, getState }) => {
        const result = await apiInstanceValidas
            .put(`validation/${validationId}/contextual_data`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                const status = error.response?.status;

                const errorMessage = status && errorCodeTranslation[status] ? errorCodeTranslation[status] : null;
                const { t } = useTranslation();
                toast.error(t(errorMessage));
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const updateVeridasUser = createAsyncThunk('document/updateVeridasUser',
    async ({ userId, validationId, ocrAndScoresResponse }) => {
        return await apiInstanceUpdate.put(`${USER_SERVICE}veridas-user/${userId}/${validationId}`, ocrAndScoresResponse, configJson)
            .then(function (response) {
                return response;
            }).catch(function (error) {
                return error.response;
            });
    },
);

export const preRegisterUser = createAsyncThunk(
    'visitor/preRegisterUser',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .post('authentication-service/pre-register-user', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


export const UpdatePrivacyConsent = createAsyncThunk('visitor/getPrivacyConsent',
    async (param, { dispatch, getState }) => {
        const response = await apiInstanceVeridas.put(`${USER_SERVICE}public/user/validate-privacy-consent/${param}`)
            .then(function (response) {
                return response;
            }).catch(function (error) {
                return error.response;
            });
        return response;
    },
);
